import classnames from 'classnames'
import classNames from 'classnames'

import BlockContent from '../BlockContent/BlockContent'
import Container from '../Container/Container'
import Ctas from '../Ctas/Ctas'
import Fixture from '../Fixture/Fixture'
import SplitTextLines from '../SplitTextLines/SplitTextLines'
import Text, { TextSizes } from '../Text/Text'

import styles from './PageHeader.module.css'

export interface PageHeaderProps {
  title: string | React.ReactNode
  summary?: string | any
  preventSplitLines?: boolean
  centered?: boolean
  testID?: string
  ctas?: any
  verticalPadding?: boolean
  noPaddingBottom?: boolean
  moduleId?: string
  bodySize?: 'default' | 'medium' | 'small'
  childComponent?: React.ReactNode
}

export default function PageHeader({
  title,
  summary,
  preventSplitLines = false,
  centered = false,
  ctas,
  testID,
  verticalPadding = false,
  noPaddingBottom = false,
  moduleId,
  bodySize = 'default',
  childComponent,
}: PageHeaderProps) {
  return (
    <div className={styles.base} data-testid={testID}>
      <Fixture
        verticalPadding={verticalPadding}
        noPaddingBottom={noPaddingBottom}
        id={moduleId}
      >
        <Container>
          <div
            className={classNames({
              [styles.centered]: centered,
              [styles.flexed]: childComponent,
            })}
          >
            <div className={styles.text}>
              <Text
                Tag="h1"
                size={TextSizes.primaryTitleXLrg}
                className={styles.title}
                dataNoSnippet={true}
              >
                {typeof title === 'string' ? (
                  preventSplitLines ? (
                    title
                  ) : (
                    <SplitTextLines text={title} />
                  )
                ) : (
                  title
                )}
              </Text>

              {summary &&
                // do a check to see whether summary is a string
                // if it is a string, render it as a text component
                // if it is an object, render it as a block content component
                (typeof summary === 'string' ? (
                  <Text
                    Tag="p"
                    size={TextSizes.secondaryTitleXLrg}
                    className={classnames(styles.summary, 'json-ld-speakable', {
                      [styles[bodySize]]: true,
                    })}
                  >
                    {summary}
                  </Text>
                ) : (
                  <>
                    <div
                      className={classnames(
                        styles.summary,
                        'json-ld-speakable',
                        {
                          [styles.isCenteredSummary]: centered,
                          [styles[bodySize]]: true,
                        }
                      )}
                    >
                      <BlockContent
                        value={summary}
                        size={TextSizes.secondaryTitleLrg}
                      ></BlockContent>
                    </div>
                  </>
                ))}
              {ctas && <Ctas hideIcon ctas={ctas} />}
            </div>
            {childComponent && (
              <div className={styles.childComponent}>{childComponent}</div>
            )}
          </div>
        </Container>
      </Fixture>
    </div>
  )
}
